import { NEW_DESIGN_SYS_COLORS } from 'components-stateless/colors';
import styled from 'styled-components';

const Label = styled.label`
  display: block;
  font-size: 12px;
  font-family: sans-serif;
  line-height: 20px;
  font-weight: 400;
  color: ${NEW_DESIGN_SYS_COLORS.LABEL_GREY};
`;

export default Label;
